import React from 'react';
import styled from 'styled-components';
import DraftstarsLogo from './draftstars-logo-inverted.png';
import PlayUpLogo from './playup-logo-inverted.svg';
import formatCurrency from '../../../utils/formatCurrency';
import dayjs from 'dayjs';
import { BsCircle, BsCheckCircleFill } from 'react-icons/bs';
enum PromotionPlatform {
	PlayUp = 1,
	Draftstars = 2,
}

const PromotionItem = ({ title, brandId, maxBonusAmount, neverExpire, expiredAt, isSelected, onSelectPromotion }) => {
	const renderBrandLogo = React.useCallback((promotionId: number) => {
		if (promotionId === PromotionPlatform.PlayUp) {
			return <BrandLogo src={PlayUpLogo} />;
		}
		if (promotionId === PromotionPlatform.Draftstars) {
			return <BrandLogo src={DraftstarsLogo} />;
		}
		return null;
	}, []);
	const brandName = React.useMemo(() => {
		switch (brandId) {
			case 1:
				return 'PlayUp';
			case 2:
				return 'Draftstars';
			default:
				return '';
		}
	}, [brandId]);

	const promotionMessage = React.useMemo(() => {
		let message = `Max${brandName && ' ' + brandName} bonus: ${formatCurrency(maxBonusAmount)}. `;
		if (brandName) {
			message += `Redeemable only on ${brandName}. `;
		}
		if (!neverExpire && expiredAt) {
			message += `Valid until ${dayjs(expiredAt).format('MMM DD [at] HH:mm a')}`;
		}
		return message;
	}, [brandName, expiredAt, maxBonusAmount, neverExpire]);

	return (
		<PromotionWrapper onClick={onSelectPromotion} selected={isSelected}>
			<LeftWrapper>
				{renderBrandLogo(brandId)}
				<PromotionDescription>
					<PromotionTitle>{title}</PromotionTitle>
					<PromotionBody>{promotionMessage}</PromotionBody>
				</PromotionDescription>
			</LeftWrapper>
			<RightWrapper>
				{isSelected ? <BsCheckCircleFill color="#01CA6E" size={20} /> : <BsCircle size={20} />}
			</RightWrapper>
		</PromotionWrapper>
	);
};
const BrandLogo = styled.img`
	height: 15px;
	margin-bottom: 5px;
`;
const PromotionWrapper = styled.li<{ selected: boolean }>`
	display: flex;
	align-items: center;
	margin-bottom: 0.25rem;
	cursor: pointer;
	background-color: #dde1e3;
	padding: 0.5em 1rem;
	border-radius: 0.25rem;
	&:hover {
		background-color: #e2e8f0;
	}
	transition: 100ms;
`;

const LeftWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
`;

const PromotionDescription = styled.div`
	flex-grow: 1;
	padding-right: 1em;
`;
const RightWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
const RadioButton = styled.input`
	cursor: pointer;
`;
const PromotionTitle = styled.p`
	font-weight: 600;
	font-size: 1.1rem;
	margin-bottom: 0.25rem;
`;

const PromotionBody = styled.p`
	font-size: 0.8em;
`;
export default PromotionItem;
